
$(document).ready(function () {
  $(document).on("click", ".atc-button--checkout", function (e) {
    e.preventDefault();
    var productHandle = $(this)
      .closest(".atc-banner--inner")
      .find(".atc--product-details--title")
      .attr("data-handle");
    console.log("product handle", productHandle);
    if (
      productHandle == "eport-g10-s-cashless-kit-upgrade" ||
      productHandle == "eport-engage-upgrade" ||
      productHandle == "eport-g10-s-cashless-kit-starter-kit" ||
      productHandle == "eport-pulse-kit-starter-kit" ||
      productHandle == "engage-test" ||
      productHandle == "yoke-w-o-cellular-starter-kit"
    ) {
      $(".custom-model-main").addClass("model-open");
      $(".custom-model-new").removeClass("model-open");
    } else {
      $(".custom-model-main").removeClass("model-open");
      $(".custom-model-new").addClass("model-open");
    }
  });
});

function notesUpdated() {
  console.log("ready!");
  var t = $(".existing-properties").attr("data-properties");
  console.log("test area", t);
  var notesVal = [];
  // var price = 0;
  $(".existing-properties").each(function () {
    var notes = $(this).attr("data-properties");
    notesVal.push(notes);
  });
  console.log("notesVal", notesVal);
  if (window.location.href.indexOf("/cart") > -1) {
    var cartNotesVal = $("#cart-note").val();
  } else {
    var cartNotesVal = " ";
  }

  console.log("cartNotesVal", cartNotesVal);
  if (
    $.inArray("Standard purchase", notesVal) >= 0 &&
    $.inArray("CTLP1", notesVal) >= 0
  ) {
    var note = "CTLP1 , Standard purchase";
    console.log("in", $("#cart-note"));
    var final_cart_note = note + " " + cartNotesVal;
    console.log("final_cart_note", final_cart_note);
    // $('#cart-note').val(note);
    $("#cart-note").val(final_cart_note);
    $("#cart-note").data("default", final_cart_note);
  } else if ($.inArray("Standard purchase", notesVal) >= 0) {
    var note = "Standard purchase";
    // $('#cart-note').val(note).change();
    var final_cart_note = note + " " + cartNotesVal;
    $("#cart-note").val(final_cart_note);
    $("#cart-note").data("default", final_cart_note);
    console.log("out yes", $("#cart-note").val());
  } else if ($.inArray("CTLP1", notesVal) >= 0) {
    console.log("out No ");
    var note = "CTLP1";
    var final_cart_note = note + " " + cartNotesVal;
    console.log("final_cart_note", final_cart_note);
    // $('#cart-note').val(note).change();
    $("#cart-note").val(final_cart_note);
    $("#cart-note").data("default", final_cart_note);
  }
}

$("input[name='terms-condition']").click(function () {
  if ($("#terms-condition").prop("checked")) {
    $(".terms_popup_error").css("visibility", "hidden");
  }
});
$("#agree_btn").click(function () {
  if ($("#terms-condition").prop("checked")) {
    $(".terms_popup_error").css("visibility", "hidden");
    notesUpdated();
    console.log("find checkout button", $("#cart-note").val());
    $("#hidden-checkout-btn").trigger("click");
    // $('#checkout-check').trigger('click');
  } else {
    $(".terms_popup_error").css("visibility", "visible");
  }
});
$(document).on(
  "click",
  ".close-btn.guest-popup-close, #cancel_btn",
  function () {
    $(".custom-model-main").removeClass("model-open");
    $("#agree_chk_error").hide();
  }
);
$("input[name='new-terms-condition']").click(function () {
  if ($("#new-terms-condition").prop("checked")) {
    notesUpdated();
    console.log("find checkout button", $("#cart-note").val());
    $("#hidden-checkout-btn").trigger("click");
    // $('#checkout-check').trigger('click');
  }
});
$(document).on("click", ".close-btn.new-guest-popup-close", function () {
  if (!$("#new-terms-condition").prop("checked")) {
    $(".custom-model-new").addClass("model-open");
    $("#new-agree_chk_error").show();
  } else {
    $(".custom-model-new").removeClass("model-open");
    $("#new-agree_chk_error").hide();
  }
});
var cartItemsId = [];
function addItem() {
  $.getJSON("/cart.js", function (t) {
    var cont = true;
    for (var e = t.items, o = 0; o < e.length; o++) {
      cartItemsId.push(e[o].handle);
    }
    console.log("cartItemsId", cartItemsId);

    if (
      $.inArray("eport-g10-s-cashless-kit-upgrade", cartItemsId) >= 0 ||
      $.inArray("eport-engage-upgrade", cartItemsId) >= 0 ||
      $.inArray("eport-g10-s-cashless-kit-starter-kit", cartItemsId) >= 0 ||
      $.inArray("eport-pulse-kit-starter-kit", cartItemsId) >= 0 ||
      $.inArray("engage-test", cartItemsId) >= 0 ||
      $.inArray("yoke-w-o-cellular-starter-kit", cartItemsId) >= 0
    ) {
      console.log("add item In");
      $("#checkout-check ,.cart-title-right button").on("click", function (e) {
        e.preventDefault();
        $(".custom-model-main").addClass("model-open");
        $(".custom-model-new").removeClass("model-open");
      });
      // $('.cart-checkout').find('#checkout-check').show();
      //  $('.cart-checkout').find('#new-checkout-check').hide();
      cont = false;
      return false;
    } else {
      console.log("add item Out");
      $("#checkout-check ,.cart-title-right button").on("click", function (e) {
        e.preventDefault();
        $(".custom-model-new").addClass("model-open");
        $(".custom-model-main").removeClass("model-open");
      });
    }
  });
}
function deleteItem(itemRemove) {
  cartItemsId = cartItemsId.filter((n) => n !== itemRemove);
  console.log("cart item remove", cartItemsId);
  if (
    $.inArray("eport-g10-s-cashless-kit-upgrade", cartItemsId) >= 0 ||
    $.inArray("eport-engage-upgrade", cartItemsId) >= 0 ||
    $.inArray("eport-g10-s-cashless-kit-starter-kit", cartItemsId) >= 0 ||
    $.inArray("eport-pulse-kit-starter-kit", cartItemsId) >= 0 ||
    $.inArray("engage-test", cartItemsId) >= 0 ||
    $.inArray("yoke-w-o-cellular-starter-kit", cartItemsId) >= 0
  ) {
    console.log("add item In");
    $("#checkout-check ,.cart-title-right button").on("click", function (e) {
      e.preventDefault();
      $(".custom-model-main").addClass("model-open");
      $(".custom-model-new").removeClass("model-open");
    });
    cont = false;
    return false;
  } else {
    console.log("add item Out");
    $("#checkout-check ,.cart-title-right button").on("click", function (e) {
      e.preventDefault();
      $(".custom-model-new").addClass("model-open");
      $(".custom-model-main").removeClass("model-open");
    });
  }
}
$(document).ready(function () {
  addItem();
});

$(document).on("click", ".cart-item--remove-link", function () {
  console.log("cart item remove");
  var itemRemove = $(this).attr("data-handle");
  console.log("itemRemove", itemRemove);
  deleteItem(itemRemove);
});

